export const PRESIDENT_START_DATE = '2025-02-01'
